import { createContext, useContext, type ReactNode } from 'react';
import { usePageNotifications, type PageNotification, type PushPageNotificationInput } from '../hooks/usePageNotifications';

type CrmPageNotificationsContextValue = {
  items: PageNotification[];
  activeToast: PageNotification | null;
  push: (input: PushPageNotificationInput) => void;
  dismissToast: () => void;
  clearAll: () => void;
};

const CrmPageNotificationsContext = createContext<CrmPageNotificationsContextValue | null>(null);

export function CrmPageNotificationsProvider({ children }: { children: ReactNode }) {
  const value = usePageNotifications();
  return (
    <CrmPageNotificationsContext.Provider value={value}>{children}</CrmPageNotificationsContext.Provider>
  );
}

export function useCrmPageNotifications(): CrmPageNotificationsContextValue {
  const ctx = useContext(CrmPageNotificationsContext);
  if (!ctx) {
    throw new Error('useCrmPageNotifications must be used within CrmPageNotificationsProvider.');
  }
  return ctx;
}
